import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';
import { AuthShell } from '../components/auth-shell';
import { returnPathFrom } from '../lib/navigation';
import { usePageTitle } from '../lib/page-title';

export function SignInPage() {
  usePageTitle('Sign in');
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setErrorMessage(null);
    const { error } = await auth.signInWithPassword({ email, password });
    setSubmitting(false);
    if (error) {
      setErrorMessage(error.message);
      return;
    }
    void navigate(returnPathFrom(location.state), { replace: true });
  }

  return (
    <AuthShell>
      <h1>Welcome back</h1>
      <p>Sign in to see today’s sentiment for your tickers.</p>
      <form className="auth-form" onSubmit={(event) => void submit(event)}>
        <label>
          Email
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {errorMessage ? (
          <p className="form-error" role="alert">
            {errorMessage}
          </p>
        ) : null}
        <button type="submit" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <div className="auth-links">
        <p>
          <Link className="text-link" to="/reset">
            Forgot your password?
          </Link>
        </p>
        <p>
          New here?{' '}
          <Link className="text-link" to="/signup">
            Create an account
          </Link>
        </p>
      </div>
    </AuthShell>
  );
}
